// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, object } from 'prop-types'
import { connect } from 'react-redux'
import UpdatedSelectDynamic from '../UpdatedSelectDynamic'

const UpdatedSelectFromState = props => (
  <UpdatedSelectDynamic {...props} />
)

UpdatedSelectFromState.propTypes = {
  options: object.isRequired,
  targetSet: array.isRequired,
}

const mapStateToProps = (state, { targetSet }) => {
  // NOTE - targetSet must be an array which follows this pattern:
  // module is the corresponding redux module. ie, "domain", "interferenceAnalysis" etc
  // path allows you to point down to the specific set from within this module.
  // eg ['domain', 'regulatory', 'bands'] points to the bands that are stored in redux.
  const [module, ...path] = targetSet
  const options = state[module].getIn(path)

  return {
    options,
  }
}

export default connect(
  mapStateToProps,
)(UpdatedSelectFromState)
